import { isNil, omitBy } from 'lodash';

import { withTitleCasedDrugFields } from 'common/utils/titleCase';
import graphqlClient from '../graphql';
import {
  cancelFillLaterItemGql,
  createFillLaterItemNowGql,
  listFillLaterItemsGql,
  mergeFillLaterItemGql,
  moveLineItemsToFillLaterGql,
  rescheduleFillLaterItemGql,
  updateFillLaterAddressGql,
} from './gql';

export const FILL_LATER_PAGE_SIZE = 25;

export const listFillLaterItemsApi = ({
  page = 1,
  limit = FILL_LATER_PAGE_SIZE,
  filter,
  sortBy,
} = {}) => {
  const offset = (page - 1) * limit;
  return graphqlClient
    .request(listFillLaterItemsGql, { limit, offset, filter: omitBy(filter, isNil), sortBy })
    .then(({ listFillLaterItems }) => ({
      ...listFillLaterItems,
      items: (listFillLaterItems.items ?? []).map(withTitleCasedDrugFields),
    }));
};

export const rescheduleFillLaterItemApi = ({ fillLaterItemId, scheduledFor }) =>
  graphqlClient
    .request(rescheduleFillLaterItemGql, { input: { fillLaterItemId, scheduledFor } })
    .then(({ rescheduleFillLaterItem }) => rescheduleFillLaterItem);

export const updateFillLaterAddressApi = ({
  fillLaterItemId,
  addressDirectoryId,
  isManuallyVerified,
}) =>
  graphqlClient
    .request(updateFillLaterAddressGql, {
      input: {
        fillLaterItemId,
        addressDirectoryId: addressDirectoryId ?? null,
        isManuallyVerified: !!isManuallyVerified,
      },
    })
    .then(({ updateFillLaterAddress }) => updateFillLaterAddress);

export const mergeFillLaterItemApi = ({ fillLaterItemId }) =>
  graphqlClient
    .request(mergeFillLaterItemGql, { input: { fillLaterItemId } })
    .then(({ mergeFillLaterItem }) => mergeFillLaterItem);

export const cancelFillLaterItemApi = ({ fillLaterItemId, cancelReason, cancelNote }) =>
  graphqlClient
    .request(cancelFillLaterItemGql, {
      input: { fillLaterItemIds: [fillLaterItemId], cancelReason, cancelNote },
    })
    .then(({ cancelFillLaterItem }) => cancelFillLaterItem);

export const moveLineItemsToFillLaterApi = ({ items }) =>
  graphqlClient
    .request(moveLineItemsToFillLaterGql, { input: { items } })
    .then(({ moveLineItemsToFillLater }) => moveLineItemsToFillLater);

export const createFillLaterItemNowApi = ({ fillLaterItemId }) =>
  graphqlClient
    .request(createFillLaterItemNowGql, { fillLaterItemId })
    .then(({ createFillLaterItemNow }) => createFillLaterItemNow);
